import { createHead } from "@unhead/vue/client";

const head = createHead();

export default head;
